import type { MerkeChip } from './Kjopere/api'

/**
 * The Top 5 merker cell on the Topp selgere / Topp kjøpere grids.
 *
 * Renders on ONE line (#594 AC2). The column used to be `w-full min-w-[300px]`
 * with wrapping chips, so it absorbed every spare pixel and still pushed rows
 * to two lines whenever an org had five brands with long names. Five chips
 * cannot be made to fit a narrow column, so the overflow is clipped to a "+N"
 * counter instead of being allowed to grow the row height.
 *
 * The full list stays reachable on hover via the title attribute — the data is
 * still there, it just no longer costs a second line.
 */
const VISIBLE = 3

export function MerkeChips({ merker }: { merker: MerkeChip[] | null | undefined }) {
  const all = merker ?? []
  if (all.length === 0) return <>—</>

  const shown = all.slice(0, VISIBLE)
  const hidden = all.slice(VISIBLE)

  return (
    <div className="flex flex-nowrap items-center gap-1">
      {shown.map(m => (
        <span
          key={m.merke}
          className="inline-flex items-center whitespace-nowrap px-1.5 py-0.5 rounded-sm text-xs bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300"
        >
          {m.merke}
        </span>
      ))}
      {hidden.length > 0 && (
        <span
          title={hidden.map(m => m.merke).join(', ')}
          className="inline-flex items-center whitespace-nowrap px-1.5 py-0.5 rounded-sm text-xs text-gray-500 dark:text-gray-400"
        >
          +{hidden.length}
        </span>
      )}
    </div>
  )
}
